
import axios from 'axios'
import { Message } from 'element-ui'
import loginUtil from '@xpeng/login-util'
import { getLocale } from '@xpeng/i18n'

// 创建axios实例
const Ajax = axios.create({
  timeout: 10000, // 请求超时时间 10s
  withCredentials: true // 允许跨域传递 cookie
})

const API_CODE = {
  SUCCESS: 200,
  UNLOGIN: 111300,
  UNAUTHORIZATION: 111301
}

// request拦截器
Ajax.interceptors.request.use(
  config => {
    config.headers = config.headers || {}
    config.headers['Accept-Language'] = getLocale()
    return config
  },
  error => {
    Message({
      message: 'HTTP Request Error',
      type: 'error',
      duration: 5 * 1000
    })
    Promise.reject(error)
  }
)

// response 拦截器
Ajax.interceptors.response.use(
  response => {
    let res = response.data

    if (res.code === API_CODE.UNLOGIN) {
      loginUtil.redirectToLogin()
      return
    }
    if (res.code === API_CODE.UNAUTHORIZATION) {
      loginUtil.redirectToAuthorization('审批管理后台')
      return
    }

    const { msg, message, code } = res
    if (code === 200) {
      return Promise.resolve(res.data)
    }
    const errorMsg = msg || message || ''
    res.msg = errorMsg
    res.message = errorMsg
    return Promise.reject(res)
  },
  error => {
    console.log(error);
    return Promise.reject(error.message)
  }
)

export default Ajax
